import { render } from "./allList.vue?vue&type=template&id=ff606f54"
import script from "./allList.vue?vue&type=script&lang=js"
export * from "./allList.vue?vue&type=script&lang=js"

import "./allList.vue?vue&type=style&index=0&id=ff606f54&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__